import api from "../../baseurl";

const Create = async (year) => {
  const Create = await api.get("events/showall").json();
  console.log(Create.data);
  return Create.data;
};

export default Create;
